<script>
	export let active;
	export let size = 12;
	export let className = '';

	$: color = active ? 'var(--color-white)' : 'var(--color-3)';
	//this icon is from embeded web v2
</script>

<svg
	class={className}
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
	width={size}
	height={size}
	fill={color}
	version="1.2"
	baseProfile="tiny"
	x="0px"
	y="0px"
	viewBox="0 0 320 320"
	overflow="visible"
	xml:space="preserve"
>
	<g id="black_bg" display="none">
		<rect display="inline" width="320" height="320" />
	</g>
	<g id="logos">
		<g>
			<path d="M7.1,180.6v117.1c0,8.4,6.8,15.3,15.3,15.3H142C141,239.8,80.9,180.7,7.1,180.6z" />
			<path
				d="M7.1,84.1v49.8c99,0.9,179.4,80.7,180.4,179.1h51.7C238.2,186.6,134.5,84.2,7.1,84.1z"
			/>
			<path
				d="M312.9,297.6V193.5C278.1,107.2,207.3,38.9,119,7.1H22.4c-8.4,0-15.3,6.8-15.3,15.3v15 c152.6,0.9,276.6,124,277.6,275.6h13C306.1,312.9,312.9,306.1,312.9,297.6z"
			/>
			<path
				d="M272.6,49.8c14.5,14.4,28.6,31.7,40.4,47.8V22.4c0-8.4-6.8-15.3-15.3-15.3h-77.3 C238.4,19.7,256.6,33.9,272.6,49.8z"
			/>
		</g>
	</g>
</svg>
